module.exports = __webpack_public_path__ + "static/img/icon_footer_logo.a6dcac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_footer_logo.png
// module id = ouqK
// module chunks = 1 5